import { ProductType as p } from "@ancon/wildcat-types";
function d(r) {
  return !!(r != null && r.items.some(
    (e) => {
      var t;
      return ((t = e.product) == null ? void 0 : t.productType) === p.PrepaidWallet;
    }
  ));
}
export {
  d as default
};
